<template>
  <div>
    <v-card min-height="390px" xs="12" md="4">
      <v-form ref="form" v-model="valid" :lazy-validation="lazy">
        <v-container>
          <v-alert
            dense
            border="top"
            type="info"
          >
            La contraseña que a continuación se solicita es de respaldo y solo será necesaria en casos aislados en los que haya alguna intermitencia en alguno de los servidores, será exclusiva de este producto. La contraseña puede ser distinta a la ya proporcionada en tu registro anterior
          </v-alert>
          <v-row justify="center">
            <v-col xs="12" md="6">
              <v-text-field
                v-model="email"
                id="signup_user_password__email__text"
                :counter="120"
                maxlength="120"
                :error-messages="getErrors('email', 'El Email')"
                label="Email"
                required
                @input="submit"
                @blur="$v.email.$touch()"
                disabled
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row justify="center">
            <v-col xs="12" md="6">
              <v-text-field
                id="signup_user_password__password__text"
                name="signup_user_password__password__text"
                v-model="password"
                :counter="50"
                maxlength="50"
                :error-messages="getErrors('password', 'La Contraseña')"
                label="Contraseña"
                required
                @input="submit"
                @blur="$v.password.$touch()"
                :append-icon="showPassword ? icon.eye : icon.eyeOff"
                @click:append="showPassword = !showPassword"
                :type="showPassword ? 'text' : 'password'"
                :disabled="isBusy"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row justify="center">
            <v-col xs="12" md="6">
              <v-text-field
                v-model="repeatPassword"
                id="signup_user_password__confirmar_password__text"
                :counter="50"
                maxlength="50"
                :error-messages="getErrors('repeatPassword', 'La contraseña')"
                label="Confirmar contraseña"
                required
                @input="submit"
                @blur="$v.repeatPassword.$touch()"
                :append-icon="showPassword ? icon.eye : icon.eyeOff"
                @click:append="repeatShowPassword = !repeatShowPassword"
                :type="repeatShowPassword ? 'text' : 'password'"
                :disabled="isBusy"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </v-card>
  </div>
</template>

<script>
import { mdiEyeOffOutline, mdiEyeOutline } from '@mdi/js'
import { required, maxLength, email, sameAs } from 'vuelidate/lib/validators'
import { panelData, panelActions } from '@/store/helpers'
import VuelidateHelper from '@/utils/VuelidateHelper'
import { strongPassword } from '@/utils/VuelidateCustoms'
import { signupActions } from '../store/signupWizardHelpers'

export default {
  name: 'SignupUserPassword',
  props: {
    correo: {
      required: true
    },
  },
  data() {
    return {
      icon: {
        eye: mdiEyeOutline,
        eyeOff: mdiEyeOffOutline
      },
      vuelidateHelper: null,
      valid: false,
      lazy: false,
      showPassword: false,
      repeatShowPassword: false,
      email: '',
      password: '',
      repeatPassword: ''
    }
  },
  created() {
    this.vuelidateHelper = new VuelidateHelper(this.$v)
    this.email = this.correo
  },
  validations: {
    email: { required, maxLength: maxLength(120), email },
    password: { required, maxLength: maxLength(50), strongPassword },
    repeatPassword: { sameAsPassword: sameAs('password') }
  },
  computed: {
    ...panelData
  },
  methods: {
    ...panelActions,
    ...signupActions,
    getErrors(campo, label = '') {
      return this.vuelidateHelper.getErrors(campo, label)
    },
    submit() {
      if (this.$refs.form.validate()) {
        if (!this.$v.$invalid) {
          this.setUserPassword({
            email: this.email,
            password: this.password
          })
        } else {
          this.setUserPassword({
            email: '',
            password: ''
          })
        }
      }
    }
  }
}
</script>
